// @flow

import React from 'react';
import styled from 'styled-components';
import type { Node } from 'react';
import { Width } from 'styles';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 32px;

  th,
  td {
    width: 50%;
    border: 1px solid #000;
    padding: 10px;
    vertical-align: text-top;
    text-align: left;

    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      padding: 24px;
    }
  }
`;

type Props = {
  tableHeadings?: Node | string[],
  columns?: Node | string[],
};

const LegalTable = ({ tableHeadings, columns, ...rest }: Props) => (
  <Table role="grid" {...rest}>
    <thead>
      <tr>
        {tableHeadings.map((tableHeading, index) => (
          <th key={`TableHeadings-${index}`}>{tableHeading}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {columns.map((column, index) => (
        <tr key={`TableRow-${index}`}>{column}</tr>
      ))}
    </tbody>
  </Table>
);

export default LegalTable;
